import { createSaga } from './saga-helpers';

import * as Api from '../api/projects-api';

const watchGetProjects = createSaga({
    type: 'PROJECTS_FETCH',
    fn: Api.fetchProjects,
    args: action => [action.payload],
    successPayload: ({ projects, hasMore } = {}, action) => ({
        projects,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateProject = createSaga({
    type: 'PROJECT_CREATE',
    fn: Api.createProject,
    args: action => [action.payload.project],
    successPayload: (project, action) => ({
        projectId: project.project_id,
        fragment: action.payload.project,
        project: {
            id: project.project_id,
            nice_id: project.nice_id,
            color: project.color,
            secondary_color: project.secondary_color,
            members: project.members,
            subteam: project.subteam,
            description: project.description,
            general_discussion: project.general_discussion,
            file_root_folder: project.file_root_folder,
            doc_root_folder: project.doc_root_folder,
            disabled_modules: project.disabled_modules,
            email: project.email
        }
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.project
    })
});

const watchGetProject = createSaga({
    type: 'PROJECT_FETCH',
    fn: Api.fetchProject,
    args: action => [action.payload.projectId],
    successPayload: project => ({ project }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        projectId: action.payload.projectId
    })
});

const watchUpdateProject = createSaga({
    type: 'PROJECT_UPDATE',
    fn: Api.updateProject,
    args: action => [action.payload.projectId, action.payload.projectProps],
    successPayload: project => ({ project })
});

const watchRemoveProject = createSaga({
    type: 'PROJECT_REMOVE',
    fn: Api.removeProject,
    args: action => [action.payload.projectId]
});

const watchDuplicateProject = createSaga({
    type: 'PROJECT_DUPLICATE',
    fn: Api.duplicateProject,
    args: action => [action.payload.projectId, action.payload.duplicateOptions],
    successPayload: () => ({
        projectId: null
    })
});

const watchInviteProjectUsers = createSaga({
    type: 'PROJECT_INVITE_USERS',
    fn: Api.inviteProjectUsers,
    args: action => [action.payload.projectId, action.payload.users],
    successPayload: (response, action) => ({
        projectId: action.payload.projectId,
        users: response.invited
    })
});

const watchJoinProject = createSaga({
    type: 'PROJECT_JOIN',
    fn: Api.joinProject,
    args: action => [action.payload.projectId]
});

const watchLeaveProject = createSaga({
    type: 'PROJECT_LEAVE',
    fn: Api.leaveProject,
    args: action => [action.payload.projectId]
});

const watchStartProject = createSaga({
    type: 'PROJECT_START',
    fn: Api.startProject,
    args: action => [action.payload.projectId]
});

const watchEnableProjectModule = createSaga({
    type: 'PROJECT_MODULE_ENABLE',
    fn: Api.enableProjectModule,
    args: action => [action.payload.projectId, action.payload.module]
});

const watchDisableProjectModule = createSaga({
    type: 'PROJECT_MODULE_DISABLE',
    fn: Api.disableProjectModule,
    args: action => [action.payload.projectId, action.payload.module]
});

const watchLinkProjectRepo = createSaga({
    type: 'PROJECT_REPO_LINK',
    fn: Api.linkProjectRepo,
    args: action => [action.payload.projectId, action.payload.provider, action.payload.repoName]
});

const watchTransferOwnership = createSaga({
    type: 'PROJECT_OWNERSHIP_TRANSFER',
    fn: Api.transferOwnership,
    args: action => [action.payload.projectId, action.payload.userId]
});

const sagas = [watchGetProjects, watchCreateProject, watchGetProject, watchUpdateProject, watchRemoveProject, watchDuplicateProject, watchInviteProjectUsers, watchJoinProject, watchStartProject, watchLeaveProject, watchEnableProjectModule, watchDisableProjectModule, watchLinkProjectRepo, watchTransferOwnership];

export default sagas;
